module.exports = __webpack_public_path__ + "static/img/12-0new1.69ecd50.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/12-0new1.png
// module id = muvQ
// module chunks = 15